import { ReactNode } from "react";

import { CustomSectionType } from "@/layouts/@types";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/components/ui/utils";

export function CustomSection({
  layout,
  children,
}: {
  layout: CustomSectionType;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "flex min-w-0 flex-wrap h-full w-full p-0 flex-col",
        layout.innerClassName,
      )}
    >
      {layout?.overline && (
        <div className="min-w-0">
          <Typography level="body-xs">{layout.overline}</Typography>
        </div>
      )}
      {layout?.renderTitle ? (
        <>{layout.renderTitle()}</>
      ) : (
        <div className="min-w-0">
          <Typography level="h2">{layout.title}</Typography>
        </div>
      )}
      {layout?.subtitle && (
        <Typography level="body-lg" className="mt-4 max-w-180 relative">
          {layout.subtitle}
        </Typography>
      )}
      {layout?.description && (
        <Typography level="body-lg" className="mt-4">
          {layout.description}
        </Typography>
      )}
      <div className="w-full h-full">{children}</div>
    </div>
  );
}
